import TalkWithUsModalIcon from './TalkWithUsModalIcon';

export const talkWithUsModalMock = {
  title: 'Talk with us',
  icon: TalkWithUsModalIcon,
};

export const talkWithUsModalMockData = {
  modalTitle: 'Talk with us modal',
  phoneSupportInfo: [
    {
      boldText: 'Brazil',
      text: 'Info',
    },
    {
      boldText: 'Brazil',
      text: 'Info',
    },
  ],
  phoneSupportInfoInBrackets: 'except holidays',
  countries: [
    {
      countryName: 'USA',
      phoneList: [
        {
          number: '487-787-454',
          infoInBrackets: '24/7',
        },
      ],
      languageList: [
        {
          language: 'English',
          info: 'option 3,5',
        },
      ],
    },
    {
      countryName: 'Germany',
      phoneList: [
        {
          number: '132-534-321',
          infoInBrackets: '24/7',
        },
      ],
      languageList: [
        {
          language: 'English',
          info: 'option 6',
        },
      ],
    },
  ],
  holidays: [
    {
      countryName: 'UK',
      days: [
        {
          holidayName: 'New Year',
          holidayDate: 'Jan 01',
        },
        {
          holidayName: 'New Year',
          holidayDate: 'Jan 01',
        },
        {
          holidayName: 'New Year',
          holidayDate: 'Jan 01',
        },
      ],
    },
    {
      countryName: 'USA',
      days: [
        {
          holidayName: 'New Year',
          holidayDate: 'Jan 01',
        },
        {
          holidayName: 'DDay',
          holidayDate: 'Feb 02',
        },
      ],
    },
    {
      countryName: 'Russia',
      days: [
        {
          holidayName: 'New Year',
          holidayDate: 'Jan 01',
        },
        {
          holidayName: 'DDay',
          holidayDate: 'Feb 02',
        },
      ],
    },
    {
      countryName: 'Poland',
      days: [
        {
          holidayName: 'New Year',
          holidayDate: 'Jan 01',
        },
        {
          holidayName: 'DDay',
          holidayDate: 'Feb 02',
        },
      ],
    },
  ],
};
